import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/programs/{districtId}
export const programs = async (districtId: number) => {
  const response = await new Request().get('/ajax/programs/' + districtId)
  return Util.Obj.keysToCamel(response.data.programs)
}
